import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import KpiSummaryStaffSelector from 'components/kpi/KpiSummaryStaffSelector.component';
import { selectStylistList } from 'selectors/salonInfo.selectors';
import logger from 'utils/logger.util';

const L = logger('KpiPage');

const KpiPage = ({ stylists }) => {
  const handleEvent = useCallback((ev) => {
    L.debug('handleEvent()', ev);
  }, []);

  L.debug('()');

  return (
    <div data-bem="KpiPage">
      <KpiSummaryStaffSelector stylists={stylists} onApply={handleEvent} onCancel={handleEvent} onClose={handleEvent} />
    </div>
  );
};

const KpiPageHoc = connect(
  (state) => ({
    stylists: selectStylistList(state),
  }),
  (dispatch) => bindActionCreators({}, dispatch),
)(KpiPage);

// noinspection JSUnusedGlobalSymbols
export default KpiPageHoc;
